import ReactRailsUJS from "@shared/polyfill/react_ujs";

const componentRequireContext = require.context("login", false);
// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(componentRequireContext);
